module.exports = __webpack_public_path__ + "img/emerald_dragon_roost_small.470ba5d4.png";